export default __webpack_public_path__ + "static/media/plain.24cb0e4d.png";